// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvidencijaDolazakaCard_h3__lTuS-,
.EvidencijaDolazakaCard_btnText__eobS8 {
  font-size: 20px;
  font-weight: 600;
  font-family: "Inter";
  color: #5f6d7e;
}

.EvidencijaDolazakaCard_dropdown__pxd5L {
  width: 100%;
  background-color: #f8f9fb;
  border: 1px solid #e0e0e0;
  height: 48px;
  border-radius: 10px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.EvidencijaDolazakaCard_btnText__eobS8 {
  font-size: 16px;
}

.EvidencijaDolazakaCard_dropdown__pxd5L:hover {
  cursor: pointer;
}

.EvidencijaDolazakaCard_container__iAD5L {
  margin-bottom: 60px;
}

.EvidencijaDolazakaCard_loadingContainer__uGZuB {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 13%;
}

.EvidencijaDolazakaCard_names__oRGt0 {
  text-decoration: none;
  color: #5f6d7e;
  font-family: "Inter";
  font-size: 14px;
  font-weight: 500;
  width: 130px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.EvidencijaDolazakaCard_dropedDiv__UDUHT {
  display: flex;
  gap: 20px;
  border: 1px solid #e0e0e0;
  height: 50px;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.EvidencijaDolazakaCard_checkbox__uxBSS {
  height: 16px;
  width: 16px;
}

/* Hide the default checkbox */
.EvidencijaDolazakaCard_checkbox__uxBSS {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  cursor: pointer;
  height: 20px;
  position: relative;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
}

.EvidencijaDolazakaCard_checkbox__uxBSS:checked::before {
  content: "✔";
  color: white;
  display: block;
  width: 19px;
  height: 19px;
  position: absolute;
  font-size: 14px;
  text-align: center;
  line-height: 19px;
  background-color: #cb9c2d;
  border-radius: 2px;
  border: none;
}

.EvidencijaDolazakaCard_firstRow__dS-tO {
  display: flex;
  gap: 20px;
  background-color: #f8f9fb;
  border-radius: 10px 10px 0 0;
  border: 1px solid #e0e0e0;
  justify-content: flex-start;
  align-items: center;
  height: 40px;
  width: 100%;
  box-sizing: border-box;
}

.EvidencijaDolazakaCard_h4__ogCyv,
.EvidencijaDolazakaCard_p__GUi6q {
  font-size: 14px;
  font-weight: 500;
  font-family: "Inter";
  color: #5f6d7e;
}

.EvidencijaDolazakaCard_h4__ogCyv {
  width: 170px;
  padding-left: 25px;
}

.EvidencijaDolazakaCard_p__GUi6q {
  width: 27px;
}

.EvidencijaDolazakaCard_img__u65Pi {
  width: 35px;
  height: 35px;
}

.EvidencijaDolazakaCard_lastRow__glrPE {
  display: flex;
  gap: 20px;
  border-radius: 0 0 10px 10px;
  border: 1px solid #e0e0e0;
  justify-content: center;
  align-items: center;
  height: 50px;
  margin-bottom: 70px;
}

.EvidencijaDolazakaCard_polaznik__zAqJx {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding-left: 19px;
}

.EvidencijaDolazakaCard_profile__AY-AG {
  height: 30px;
  width: 30px;
}

.EvidencijaDolazakaCard_polazniciContainer__m2pPs {
  overflow: hidden;
  width: 100%;
}

.EvidencijaDolazakaCard_input__oZLCK:last-child {
  padding-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencijaDolazaka/components/EvidencijaDolazakaCard.module.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".h3,\n.btnText {\n  font-size: 20px;\n  font-weight: 600;\n  font-family: \"Inter\";\n  color: #5f6d7e;\n}\n\n.dropdown {\n  width: 100%;\n  background-color: #f8f9fb;\n  border: 1px solid #e0e0e0;\n  height: 48px;\n  border-radius: 10px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n.btnText {\n  font-size: 16px;\n}\n\n.dropdown:hover {\n  cursor: pointer;\n}\n\n.container {\n  margin-bottom: 60px;\n}\n\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 13%;\n}\n\n.names {\n  text-decoration: none;\n  color: #5f6d7e;\n  font-family: \"Inter\";\n  font-size: 14px;\n  font-weight: 500;\n  width: 130px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n}\n\n.dropedDiv {\n  display: flex;\n  gap: 20px;\n  border: 1px solid #e0e0e0;\n  height: 50px;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.checkbox {\n  height: 16px;\n  width: 16px;\n}\n\n/* Hide the default checkbox */\n.checkbox {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 20px;\n  cursor: pointer;\n  height: 20px;\n  position: relative;\n  border: 1px solid #e2e2e2;\n  border-radius: 4px;\n}\n\n.checkbox:checked::before {\n  content: \"✔\";\n  color: white;\n  display: block;\n  width: 19px;\n  height: 19px;\n  position: absolute;\n  font-size: 14px;\n  text-align: center;\n  line-height: 19px;\n  background-color: #cb9c2d;\n  border-radius: 2px;\n  border: none;\n}\n\n.firstRow {\n  display: flex;\n  gap: 20px;\n  background-color: #f8f9fb;\n  border-radius: 10px 10px 0 0;\n  border: 1px solid #e0e0e0;\n  justify-content: flex-start;\n  align-items: center;\n  height: 40px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.h4,\n.p {\n  font-size: 14px;\n  font-weight: 500;\n  font-family: \"Inter\";\n  color: #5f6d7e;\n}\n\n.h4 {\n  width: 170px;\n  padding-left: 25px;\n}\n\n.p {\n  width: 27px;\n}\n\n.img {\n  width: 35px;\n  height: 35px;\n}\n\n.lastRow {\n  display: flex;\n  gap: 20px;\n  border-radius: 0 0 10px 10px;\n  border: 1px solid #e0e0e0;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n  margin-bottom: 70px;\n}\n\n.polaznik {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  padding-left: 19px;\n}\n\n.profile {\n  height: 30px;\n  width: 30px;\n}\n\n.polazniciContainer {\n  overflow: hidden;\n  width: 100%;\n}\n\n.input:last-child {\n  padding-right: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"h3": `EvidencijaDolazakaCard_h3__lTuS-`,
	"btnText": `EvidencijaDolazakaCard_btnText__eobS8`,
	"dropdown": `EvidencijaDolazakaCard_dropdown__pxd5L`,
	"container": `EvidencijaDolazakaCard_container__iAD5L`,
	"loadingContainer": `EvidencijaDolazakaCard_loadingContainer__uGZuB`,
	"names": `EvidencijaDolazakaCard_names__oRGt0`,
	"dropedDiv": `EvidencijaDolazakaCard_dropedDiv__UDUHT`,
	"checkbox": `EvidencijaDolazakaCard_checkbox__uxBSS`,
	"firstRow": `EvidencijaDolazakaCard_firstRow__dS-tO`,
	"h4": `EvidencijaDolazakaCard_h4__ogCyv`,
	"p": `EvidencijaDolazakaCard_p__GUi6q`,
	"img": `EvidencijaDolazakaCard_img__u65Pi`,
	"lastRow": `EvidencijaDolazakaCard_lastRow__glrPE`,
	"polaznik": `EvidencijaDolazakaCard_polaznik__zAqJx`,
	"profile": `EvidencijaDolazakaCard_profile__AY-AG`,
	"polazniciContainer": `EvidencijaDolazakaCard_polazniciContainer__m2pPs`,
	"input": `EvidencijaDolazakaCard_input__oZLCK`
};
export default ___CSS_LOADER_EXPORT___;
